if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        this.onButtonClick = this.onButtonClick.bind(this);
      }

      connectedCallback() {
        const button = this.querySelector('button');
        if (!button || button === this.button) return;

        if (this.button) this.button.removeEventListener('click', this.onButtonClick);

        this.button = button;
        this.button.addEventListener('click', this.onButtonClick);
      }

      onButtonClick(event) {
        const parentDisplay = this.expandShowMore(event);
        if (!parentDisplay) return;

        const nextElementToFocus = parentDisplay.querySelector('.show-more-item:not(.hidden)');
        if (nextElementToFocus && nextElementToFocus.querySelector('input')) {
          nextElementToFocus.querySelector('input').focus();
        }
      }

      expandShowMore(event) {
        const parentDisplay = this.closest('.parent-display') || event.target.closest('.parent-display');
        if (!parentDisplay) return null;

        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }

        return parentDisplay;
      }
    }
  );
}
